import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { Grid, Container, Paper, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import CheckoutForm from './CheckoutForm';
import CheckoutSummary from './CheckoutSummary';
import { BreadCrumbs } from '../../_components';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
  },
  container: {
    maxWidth: '1400px !important',
  },
  formSection: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  summarySection: {
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
  summaryPaper: {
    position: 'sticky',
    top: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      marginBottom: theme.spacing(2),
    },
  },
  formPaper: {
    padding: theme.spacing(3),
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  breadcrumbs: {
    marginBottom: theme.spacing(3),
  },
}));

const getCartItems = (cart) => {
  if (cart?.items && Array.isArray(cart.items)) {
    return cart.items;
  }

  if (cart?.list) {
    if (Array.isArray(cart.list.all)) {
      return cart.list.all;
    }

    const mainWarehouse = cart.list.main_warehouse || [];
    const onRequest = cart.list.on_request || [];
    const notFound = cart.list.not_found_in_price || [];
    return [...mainWarehouse, ...onRequest, ...notFound];
  }

  return [];
};

const CheckoutPage = ({ cart, authentication, userSelectedData, contragentData, frontendData }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [paymentMethod, setPaymentMethod] = useState('');

  const cartItems = getCartItems(cart);

  // Захист: якщо кошик пустий
  if (!cartItems || cartItems.length === 0) {
    return <Redirect to="/cart" />;
  }

  // Примітка: Перевірка авторизації робиться в батьківському компоненті Checkout.js
  // щоб уникнути flickering та подвійних redirect

  return (
    <Box className={classes.root}>
      <Container className={classes.container}>
        {/* Хлібні крихти */}
        <Box className={classes.breadcrumbs}>
          <BreadCrumbs
            items={[
              { title: t('homePage'), path: '/' },
              { title: t('myCart'), path: '/cart' },
              { title: t('checkout'), path: '/checkout' },
            ]}
          />
        </Box>

        {/* Основний макет: Форма (ліва) + Кошик (права) */}
        <Grid container spacing={2} alignItems="flex-start" justifyContent="space-between">
          {/* ЛІВА КОЛОНКА - Форма оформлення */}
          <Grid
            item
            xs={12}
            md={8}
            className={classes.formSection}
          >
            <Paper className={classes.formPaper}>
              <CheckoutForm
                cartItems={cartItems}
                onPaymentChange={setPaymentMethod}
              />
            </Paper>
          </Grid>

          {/* ПРАВА КОЛОНКА - Кошик (фіксований) */}
          <Grid
            item
            xs={12}
            md={4}
            className={classes.summarySection}
          >
            <Box className={classes.summaryPaper}>
              <CheckoutSummary
                cartItems={cartItems}
                paymentMethod={paymentMethod}
                userSelectedData={userSelectedData}
                contragentData={contragentData}
                frontendData={frontendData}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  cart: state.cart,
  authentication: state.authentication,
  userSelectedData: state.userSelectedData,
  contragentData: state.contragentData,
  frontendData: state.frontendData,
});

export default connect(mapStateToProps)(CheckoutPage);
